import { createStore } from 'satcheljs';
export default createStore('markAsReadOption', {
    behavior: null,
    delay: null,
})();
//# sourceMappingURL=store.js.map